import { styled, Tabs } from '@mui/material';

export const TabsStyled = styled(Tabs, {
  shouldForwardProp: (prop) => prop !== 'showIndicator',
})(({ theme, showIndicator }) => ({
  width: '342px',
  '& .MuiTabs-indicator': {
    display: showIndicator ? 'block' : 'none',
    backgroundColor: theme.palette.colors.highlight,
    bottom: 0,
    height: '5px',
    borderRadius: 3,
  },
  minHeight: 34,
  marginBottom: -3,
  '& .MuiTabs-flexContainer': {
    [theme.breakpoints.up('lg')]: {
      justifyContent: 'start',
    },
  },
  [theme.breakpoints.up('md')]: {
    width: '603px',
  },
  [theme.breakpoints.up('lg')]: {
    width: '100%',
  },
}));

export const TabsWrapperStyled = styled('div', {
  shouldForwardProp: (prop) =>
    prop !== 'variant' &&
    prop !== 'mainTabContainer' &&
    prop !== 'hasChildren' &&
    prop !== 'stockExchangeDetails' &&
    prop !== 'stockExchangeDetailsCurrentSlide' &&
    prop !== 'isFundsDetailsPage',
})(({
  theme,
  variant,
  mainTabContainer,
  stockExchangeDetails,
  stockExchangeDetailsCurrentSlide,
  isFundsDetailsPage,
  hasChildren,
}) => {
  const getMarginTop = () => {
    if (mainTabContainer)
      return {
        marginTop: '6px',
        [theme.breakpoints.up('md')]: {
          marginTop: '14px',
        },
        [theme.breakpoints.up('lg')]: {
          marginTop: '16px',
        },
      };

    if (stockExchangeDetails)
      return {
        marginTop: '10px',
      };

    return { marginTop: '21px' };
  };

  const getMarginBottom = () => {
    if (isFundsDetailsPage)
      return {
        marginBottom: stockExchangeDetailsCurrentSlide === 0 && '42px',
      };

    return {
      marginBottom:
        stockExchangeDetailsCurrentSlide === 0
          ? '16px'
          : stockExchangeDetailsCurrentSlide === 1 && '42px',
    };
  };

  return {
    display: 'flex',
    flexDirection: 'row',
    borderBottom: `1px solid ${theme.palette.colors.highlight}`,
    paddingLeft: 0,
    ...getMarginTop(),
    ...getMarginBottom(),
    width: variant === 'innerTabs' ? 'auto' : '100%',
    marginLeft: variant === 'innerTabs' ? 8 : 0,
    marginRight: variant === 'innerTabs' ? 8 : 0,
    justifyContent: 'center',

    [theme.breakpoints.up('lg')]: {
      paddingRight: hasChildren && '64px',
    },
  };
});
